import request from '@/plugin/axios'

export function ListDiffs (data) {
  return request({
    url: '/diff/index',
    method: 'get',
    params: data
  })
}

export function GetAssistItems () {
  return request({
    url: '/diff/assist-items',
    method: 'get'
  })
}

export function ExportDiffs (id) {
  return request({
    url: '/diff/export?id=' + id,
    method: 'post',
    responseType: 'arraybuffer'
  })
}

export function DoCompare () {
  return request({
    url: '/diff/compare',
    method: 'post'
  })
}
